export default {"src":"/_next/static/media/km.c300e40c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};